export default __webpack_public_path__ + "static/media/PlayerEliminated.2d0df94f.png";